/*
 *  -----------------------------------------------------------------------
 *    <copyright file="rag-detail-template.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useTranslation } from '@hooks/index';
import Constants from '@utils/constants';
import ExpandableItem from '@components/core/expandable/item';
import RAGMap from '@pages/admin/organisations/admin-evaluation-models/rag-map';
import './styles.scss';

const RagDetailTemplate = ({
    ragMap,
    labels,
    includeDetectability,
    action,
    onChange,
    setOption,
    isEvaluationModelUsed,
}: {
    ragMap: any;
    labels: any[];
    includeDetectability: boolean;
    action: number;
    onChange: Function;
    setOption: Function;
    isEvaluationModelUsed: boolean;
}) => {
    const { t } = useTranslation();
    const [selectedColor, setSelectedColor] = useState(action);

    useEffect(() => {
        setSelectedColor(action);
    }, [action]);

    const disabled = isEvaluationModelUsed ? 'disabled' : '';

    return (
        <ExpandableItem header="Scoring Map" isExpanded>
            <div className="rag-wrapper">
                <div className="rag-color">
                    <div
                        className={`color-item green ${
                            selectedColor === Constants.RagMapOptions.GREEN ? 'selected' : ''
                        } ${disabled}`}
                        onClick={() => {
                            if (!disabled) {
                                setSelectedColor(Constants.RagMapOptions.GREEN);
                                setOption(Constants.RagMapOptions.GREEN);
                            }
                        }}
                    >
                        <FontAwesomeIcon className="paint-brush" icon={['fal', 'paint-brush']} />
                    </div>
                    <div
                        className={`color-item amber ${
                            selectedColor === Constants.RagMapOptions.AMBER ? 'selected' : ''
                        } ${disabled}`}
                        onClick={() => {
                            if (!disabled) {
                                setSelectedColor(Constants.RagMapOptions.AMBER);
                                setOption(Constants.RagMapOptions.AMBER);
                            }
                        }}
                    >
                        <FontAwesomeIcon className="paint-brush" icon={['fal', 'paint-brush']} />
                    </div>
                    <div
                        className={`color-item red ${
                            selectedColor === Constants.RagMapOptions.RED ? 'selected' : ''
                        } ${disabled}`}
                        onClick={() => {
                            if (!disabled) {
                                setSelectedColor(Constants.RagMapOptions.RED);
                                setOption(Constants.RagMapOptions.RED);
                            }
                        }}
                    >
                        <FontAwesomeIcon className="paint-brush" icon={['fal', 'paint-brush']} />
                    </div>
                    <div
                        className={`color-item blue ${
                            selectedColor === Constants.RagMapOptions.MOVE ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setSelectedColor(Constants.RagMapOptions.MOVE);
                            setOption(Constants.RagMapOptions.MOVE);
                        }}
                    >
                        <FontAwesomeIcon className="paint-brush" icon={['fal', 'arrows']} />
                    </div>
                </div>
                <RAGMap
                    id="rag-map"
                    ragMap={ragMap}
                    labels={labels}
                    includeDetectability={includeDetectability}
                    action={action}
                    onChange={onChange}
                />
            </div>
        </ExpandableItem>
    );
};

export default RagDetailTemplate;
